import { Injectable } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { RendererFactory2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { ResultpageService } from './resultpage.service';
import { LoginService } from './login.service';
import { OfferDataUtilsService } from './offer-data-utils.service';
import { CacheService } from './cache.service';
import { EternalPageService } from './eternal-page.service';
import { Result } from '../type/result_type';

@Injectable({
  providedIn: 'root',
})
export class ActiveService extends EternalPageService {
  constructor(
    route: ActivatedRoute,
    resultpageService: ResultpageService,
    location: PlatformLocation,
    rendererFactory: RendererFactory2,
    loginService: LoginService,
    offerDataUtils: OfferDataUtilsService,
    cacheService: CacheService
  ) {
    super(
      route,
      resultpageService,
      location,
      rendererFactory,
      loginService,
      offerDataUtils,
      cacheService
    );
  }

  protected getApiData(): Observable<Result> {
    return this.resultpageService.getActiveData();
  }

  protected postApiFilter(obj: any): Observable<Result> {
    return this.resultpageService.postActiveFilter(obj);
  }

  protected getGtmEventName(): string {
    return 'active-page';
  }
}
